import { trans } from "@mongez/localization";
import { CartItem, useCartItemQuantity } from "core/cart";
import { checkoutAtom } from "core/checkout";
import { userAtom } from "core/user";
import { Minus, Plus, Trash2Icon } from "lucide-react";
import { errorToast, successToast } from "~/design-system/components";
import { triggerCartRemoved, triggerCartUpdated } from "~/modules/cart/events";

export function CartDrawerItemQuantity({ item }: { item: CartItem }) {
  const quantity = item.quantity;

  const minQuantity = item.product.purchase?.minQuantity || 1;

  const { decrementOrRemoveItem, incrementQuantity, loading, removeItem } =
    useCartItemQuantity(item, {
      onSuccess: (data) => {
        if (quantity === 1 || quantity === minQuantity) {
          triggerCartRemoved({
            cart: data.cart,
            product: item.product,
          });
        } else {
          triggerCartUpdated({
            cart: data.cart,
            product: item.product,
          });
        }
        checkoutAtom.update((prev) => ({
          ...prev,
          cart: data.cart,
        }));
        userAtom.update(data.user);

        const isRemoved = !data.cart.items.some(
          (cartItem: CartItem) => cartItem.id === item.id,
        );
        if (isRemoved) {
          successToast(trans("cart.itemRemovedSuccess"));
        } else {
          successToast(trans("cart.quantityUpdated"));
        }
      },
      onError: (error) => {
        errorToast(error);
      },
    });

  return (
    <div className="flex flex-col gap-2">
      <div className="animate-fade-in flex h-[37px] items-center justify-between gap-2 rounded-full border bg-[#FFF4F6] px-3.5">
        {quantity === 1 || quantity === minQuantity ? (
          <button
            type="button"
            title={trans("removeFromCart")}
            aria-label={trans("removeFromCart")}
            className="cursor-pointer"
            onClick={decrementOrRemoveItem}
            disabled={loading}
          >
            <Trash2Icon width={16} height={16} />
          </button>
        ) : (
          <button
            type="button"
            title={trans("decreaseQuantity")}
            aria-label={trans("decreaseQuantity")}
            className="cursor-pointer"
            onClick={decrementOrRemoveItem}
            disabled={loading}
          >
            <Minus width={16} height={16} />
          </button>
        )}
        <div className="mb-1 w-[20px] text-center font-semibold transition-all">
          {loading ? "..." : quantity}
        </div>
        <button
          type="button"
          title={trans("increaseQuantity")}
          aria-label={trans("increaseQuantity")}
          className="cursor-pointer"
          onClick={incrementQuantity}
          disabled={loading}
        >
          <Plus width={16} height={16} />
        </button>
      </div>
      {/* <div className="animate-fade-in flex h-[37px] items-center gap-2 rounded-full border bg-[#FFF4F6] px-3.5">
        <button
          type="button"
          title={trans("removeFromCart")}
          aria-label={trans("removeFromCart")}
          className="flex w-full cursor-pointer items-center justify-center gap-2"
          onClick={removeItem}
          disabled={loading}
        >
          <Trash2Icon width={16} height={16} />
          <span className="text-sm">{loading ? "..." : trans("remove")}</span>
        </button>
      </div> */}
    </div>
  );
}
